<!--cxone modal -->
<div [ngClass]="{'cxone-custom-dialog': isCXone,'cxone-sol-modal': isCXone && dialogType > 10}" class="{{customModalClass}}">
    <div class="modal-header">
        <div class="modal-header-container">
            <div>
                <svg [class]="iconStyle" [innerHTML]="iconDialogHref">
                </svg>
            </div>
            <div>
                <h4 class="modal-header-title">{{title}}</h4>
            </div>
            <div>
                <button type="button" class="icon-btn modal-close" aria-describedby="modal-title" (click)="modal.dismiss()">
                    <svg class="icon-12 fill-iconDefault" [innerHTML]="iconCloseHref">
                    </svg>
                </button>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="isArray">
            <ul *ngIf="!isInnerHtml">
                <li *ngFor="let sanitizedString of sanitizedArray">{{sanitizedString}}</li>
            </ul>
            <ng-container *ngIf="isInnerHtml">
              <ul *ngFor="let sanitizedString of sanitizedArray" [innerHTML]="sanitizedString"></ul>
            </ng-container>
        </ng-container>
        <p *ngIf="!isInnerHtml" class="modal-body-text">{{body}}</p>
        <div *ngIf="isInnerHtml" [innerHTML]="safeBodyHtml"></div>
    </div>
    <div [ngClass]="{'modal-footer': true, 'cxone-modal-footer': isCXone}" [class]="footerBorderColorClass">
        <ng-container [ngSwitch]="dialogType">
            <ng-container *ngSwitchCase="11">
                <div class="d-flex gap-7" [hidden]="isLoadingStyles">
                    <sol-button class="sol-buttons-design" type="button" variant="warn" (onClick)="modal.close()" ngbAutofocus size="large">
                        <span>{{confirmButtonText}}</span>
                    </sol-button>
                    <sol-button class="sol-buttons-design" type="button" variant="basic" (onClick)="modal.dismiss()" *ngIf="cancelButtonText != ''" size="large">
                        <span>{{cancelButtonText}}</span>
                    </sol-button>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="12">
                <div class="d-flex gap-7" [hidden]="isLoadingStyles">
                    <sol-button class="sol-buttons-design" type="button" variant="basic" (onClick)="modal.close()" ngbAutofocus size="large">
                        <span>{{confirmButtonText}}</span>
                    </sol-button>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="13">
                <div class="d-flex gap-7" [hidden]="isLoadingStyles">
                    <sol-button class="sol-buttons-design" type="button" variant="basic" (onClick)="modal.close()" ngbAutofocus size="large">
                        <span>{{confirmButtonText}}</span>
                    </sol-button>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="14">
                <div class="d-flex gap-7" [hidden]="isLoadingStyles">
                    <sol-button class="sol-buttons-design" type="button" variant="basic" (onClick)="modal.dismiss()" size="large">
                        <span>{{cancelButtonText}}</span>
                    </sol-button>
                    <sol-button class="sol-buttons-design" type="button" variant="primary" (onClick)="modal.close()" *ngIf="cancelButtonText != ''" size="large" ngbAutofocus>
                        <span>{{confirmButtonText}}</span>
                    </sol-button>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div class="d-flex gap-7" [hidden]="isLoadingStyles">
                    <button type="button" [class]="buttonCancelClass" (click)="modal.dismiss()" *ngIf="cancelButtonText != ''">
                        <span>{{cancelButtonText}}</span>
                    </button>
                    <button type="button" [class]="buttonConfirmClass" (click)="modal.close()" ngbAutofocus>
                        <span>{{confirmButtonText}}</span>
                    </button>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
